// ======================================================================
// File Name       : NoticeServiceDetailDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import reactStringReplace from 'react-string-replace';
import { connect } from 'react-redux';
import { Form, Button, Col, Row } from 'react-bootstrap';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { parseDateForDetail } from '../../utils/index';
import { DEFAULT_DATE_FORMAT, REG_EXP } from '../../constants/index';

class NoticeServiceDetailDialog extends React.Component {
  constructor(props) {
    super(props);
    this.getModalOptions = this.getModalOptions.bind(this);
  }

  getModalOptions() {
    return {
      title: '',
      bsSize: 'md',
      fixedHeight: false,
      footerBtns: [
        {
          name: 'OK',
          onClick: this.props.hideModal,
          variant: 'primary',
        },
      ],
    };
  }

  render() {
    const { noticeService } = this.props;
    return (
      <ModalWrapper temporaryHide={''} {...this.getModalOptions()} hideModal={this.props.hideModal} title={noticeService.noticeTitle}>
        <Form.Group className="form-info">
          <Row>
            <Col as={Form.Label} xs={3} className="padding-left-clear">
              お知らせ内容
            </Col>
            <Col xs={1} className="padding-left-right-clear">：</Col>
            <Col xs={8} className="padding-left-right-clear padding-bottom-20">
              {reactStringReplace(noticeService.noticeContent, REG_EXP, (match, i) => (
                <a target="blank" href={match}>{match}</a>
              ))}
            </Col>
          </Row>
        </Form.Group>
        <Form.Group className="form-info">
          <Row>
            <Col as={Form.Label} xs={3} className="padding-left-clear">
              登録日
            </Col>
            <Col xs={1} className="padding-left-right-clear">：</Col>
            <Col xs={8} className="padding-left-right-clear padding-bottom-20">
              {parseDateForDetail(noticeService.createdAt, DEFAULT_DATE_FORMAT)}
            </Col>
          </Row>
        </Form.Group>
        <Form.Group className="form-info">
          <Row>
            <Col as={Form.Label} xs={3} className="padding-left-clear">
              登録者
            </Col>
            <Col xs={1} className="padding-left-right-clear">：</Col>
            <Col xs={8} className="padding-left-right-clear padding-bottom-20">
              {noticeService.authorName}
            </Col>
          </Row>
        </Form.Group>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
});

export default connect(mapStateToProps)(NoticeServiceDetailDialog);
